// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateWorkbookParameterSetsMutationVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  variantId: Types.Scalars["ID"]["input"];
  parameterSet?: Types.InputMaybe<Types.Scalars["JSON"]["input"]>;
  queryText?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  querySampleIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
  finalize?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type CreateWorkbookParameterSetsMutation = {
  __typename?: "Mutation";
  createWorkbookParameterSets?: {
    __typename?: "Workbook";
    id: string;
    parameterRefAliases: Array<string>;
    parameterSets: Array<{
      __typename?: "WorkbookParameterSet";
      id: string;
      name: string;
      paramValues: any;
    }>;
    aliasParamMapList: Array<{
      __typename?: "AliasParamMap";
      id: string;
      name: string;
      parameters: any;
    }>;
  } | null;
};

export const CreateWorkbookParameterSetsDocument = gql`
  mutation CreateWorkbookParameterSets(
    $databaseId: ID!
    $variantId: ID!
    $parameterSet: JSON
    $queryText: String
    $querySampleIds: [ID!]
    $finalize: Boolean
  ) {
    createWorkbookParameterSets(
      databaseId: $databaseId
      variantId: $variantId
      parameterSet: $parameterSet
      queryText: $queryText
      querySampleIds: $querySampleIds
      finalize: $finalize
    ) {
      id
      parameterSets {
        id
        name
        paramValues
      }
      parameterRefAliases
      aliasParamMapList {
        id
        name
        parameters
      }
    }
  }
`;
export type CreateWorkbookParameterSetsMutationFn = Apollo.MutationFunction<
  CreateWorkbookParameterSetsMutation,
  CreateWorkbookParameterSetsMutationVariables
>;

/**
 * __useCreateWorkbookParameterSetsMutation__
 *
 * To run a mutation, you first call `useCreateWorkbookParameterSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkbookParameterSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkbookParameterSetsMutation, { data, loading, error }] = useCreateWorkbookParameterSetsMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      variantId: // value for 'variantId'
 *      parameterSet: // value for 'parameterSet'
 *      queryText: // value for 'queryText'
 *      querySampleIds: // value for 'querySampleIds'
 *      finalize: // value for 'finalize'
 *   },
 * });
 */
export function useCreateWorkbookParameterSetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkbookParameterSetsMutation,
    CreateWorkbookParameterSetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkbookParameterSetsMutation,
    CreateWorkbookParameterSetsMutationVariables
  >(CreateWorkbookParameterSetsDocument, options);
}
export type CreateWorkbookParameterSetsMutationHookResult = ReturnType<
  typeof useCreateWorkbookParameterSetsMutation
>;
export type CreateWorkbookParameterSetsMutationResult =
  Apollo.MutationResult<CreateWorkbookParameterSetsMutation>;
export type CreateWorkbookParameterSetsMutationOptions =
  Apollo.BaseMutationOptions<
    CreateWorkbookParameterSetsMutation,
    CreateWorkbookParameterSetsMutationVariables
  >;
